import { weightSchemaAgainstModel } from './weight-schemas-against-model';
export const getAppliedSchemaIndex = (model, oneOfSchemaList, definitions = {}) => {
    const schemaPoints = oneOfSchemaList
        .map(({ schema }, index) => {
        const points = weightSchemaAgainstModel(model, schema, definitions);
        return { index, points };
    })
        .filter((weigthedSchema) => weigthedSchema.points > 0)
        .sort((a, b) => b.points - a.points);
    return schemaPoints.length > 0 ? schemaPoints[0].index : -1;
};
//# sourceMappingURL=get-applied-schema-index.js.map